
import {
  Container,
  Typography,
  IconButton,
  Grid,
  Paper
} from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import { ILogo } from '../../../styles/components/ILogo';
import InfoIcon from '@mui/icons-material/Info';
export default function Header(props: any) {
  return (
    <Container maxWidth="sm" style={{ marginTop: '10px' }}>
      <IconButton
        href="https://github.com/release-pilot/release-pilot-public/tree/master/release-planner"
        target="_blank"
        rel="noopener"
        color="primary"
        style={{ position: 'absolute', top: 0, right: 0, margin: '10px' }}
      >
        <GitHubIcon fontSize="large" />
      </IconButton>
      <Grid sx={{ paddingTop: 2, alignContent: 'center' }}>
        <center>
          <ILogo src="/assets/Single_mainlogo_tm.png" />
        </center>
      </Grid>
      <Paper elevation={3} style={{ padding: '10px', marginTop: '10px' }}>
        <IconButton color="primary">
          <InfoIcon fontSize="small" />
          <Typography variant="body1">
            The Release Planner application enables seamless communication and coordination of release plans across all peer
            products, ensuring a smooth and efficient deployment process.
          </Typography>
        </IconButton>
      </Paper>

      {props.children}

      {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
        <Typography variant="body1" style={{ marginLeft: '5px', fontSize: '24px' }}>
          Crafted with ❤️ in India
        </Typography>
      </div> */}
    </Container>
  );
}
